import { ValueLabel } from '../../components/config/options-adder/interfaces';

import { FetchingProgress, GadgetConfig } from './model';

export const CUSTOMFIELDS_ADMIN_PAGE_PATH = '/secure/admin/ViewCustomFields.jspa';
export const JIRA_DASHBOARD_GADGET_REFRESH = 'JIRA_DASHBOARD_GADGET_REFRESH';
export const GADGET_DATA_FETCHED = 'GADGET_DATA_FETCHED';

export const MAX_RESULTS = 100;

export const ASSIGNEE = 'assignee';
export const PRIORITY = 'priority';
export const STATUS = 'status';
export const STATUS_CATEGORY = 'statusCategory';
export const GROUPING_FIELDS = [ASSIGNEE, PRIORITY, STATUS];
export const CUSTOM_FIELD_PREFIX = 'customfield_';

export const DEFAULT_GROUPING_OPTION = STATUS_CATEGORY;
export const DEFAULT_GROUPING_VALUE_LABEL = { label: 'Status category', value: STATUS_CATEGORY };
export const GROUPING_OPTIONS: ValueLabel[] = [
    { label: 'Assignee', value: ASSIGNEE },
    { label: 'Priority', value: PRIORITY },
    DEFAULT_GROUPING_VALUE_LABEL,
    { label: 'Status', value: STATUS },
];

export const DEFAULT_CONFIG: GadgetConfig = {
    fieldId: '',
    groupingFieldId: DEFAULT_GROUPING_OPTION,
    jql: '',
    hideEmptyValues: false,
};

export const DEFAULT_FETCHING_PROGRESS: FetchingProgress = {
    gadgetId: '',
    isFetching: false,
    currentNumber: 0,
    total: 0,
};

export const NAME = 'name';
export const ACCOUNT_ID = 'accountId';
export const UNASSIGNED = 'Unassigned';
export const PRIORITY_INDEX = 0;
export const STATUS_INDEX = 1;
export const STATUS_CATEGORY_INDEX = 2;
export const ASSIGNEE_INDEX = 3;

export const GROUP_NAME_TO_INDEX = {
    [ASSIGNEE]: ASSIGNEE_INDEX,
    [PRIORITY]: PRIORITY_INDEX,
    [STATUS]: STATUS_INDEX,
    [STATUS_CATEGORY]: STATUS_CATEGORY_INDEX,
};
